/* eslint-disable react/require-default-props */
/* eslint-disable camelcase */
/* eslint-disable no-undef */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/default-props-match-prop-types */
/* eslint-disable react/react-in-jsx-scope */
import React from 'react';
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Row } from 'reactstrap';
import { Modal } from '..';
import PropTypes from 'prop-types';
import axios from 'axios';
import { toast } from 'react-toastify';

export default function EditCustomerModal({ id, customer }) {
  const [liveDurationOptions, setLiveDurationOptions] = React.useState([20, 30, 40, 50, 60]);
  const [selectedDuration, setSelectedDuration] = React.useState(30);

  const onEditCustomer = () => {
    if (selectedDuration && customer) {
      axios
        .put(`/api/v2/admin/users/${customer._id}`, {
          live_duration: Number(selectedDuration),
        })
        .then(() => toast.success('Update customer successfully!'))
        .catch(() => toast.error('Oops! Some thing went wrong'));
    }
  };
  React.useEffect(() => {
    if (customer.live_duration) {
      setSelectedDuration(customer.live_duration);
    }
  }, [customer]);
  return (
    customer && (
      <Modal id={id}>
        <div className="modal-content">
          <Row>
            <Col xs="12">
              <Card>
                <CardHeader>
                  <div className="modal-heading">
                    <div className="modal__title">Edit Customer</div>
                    <button
                      type="button"
                      data-dismiss="modal"
                      className="close align-self-baseline"
                      aria-label="Close"
                    >
                      <span>&times;</span>
                    </button>
                  </div>
                </CardHeader>
                <CardBody>
                  <Row>
                    <Col xs="12">
                      <div className="form-group">
                        <small htmlFor="select-box" className="mb-1">
                          Live duration (minutes)
                        </small>
                        <select
                          id="select-box"
                          name="select-box"
                          className="form-select form-control rounded appearance-auto rounded-30"
                          onChange={e => setSelectedDuration(e.target.value)}
                          value={selectedDuration}
                        >
                          {liveDurationOptions.map((option, index) => (
                            <option value={option} key={index}>
                              {option}
                            </option>
                          ))}
                        </select>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter className="d-flex justify-content-end align-items-center  ">
                  <Button color="success" data-dismiss="modal" onClick={onEditCustomer}>
                    Save
                  </Button>
                  <Button
                    className="ml-2"
                    color="outline-danger"
                    aria-label="Close"
                    data-dismiss="modal"
                  >
                    Cancel
                  </Button>
                </CardFooter>
              </Card>
            </Col>
          </Row>
        </div>
      </Modal>
    )
  );
}

EditCustomerModal.defaultProps = {
  id: null,
};

EditCustomerModal.propTypes = {
  id: PropTypes.string.isRequired,
  customer: PropTypes.object,
};



// WEBPACK FOOTER //
// ./client/react/Admin/components/EditCustomerModal/index.jsx